import React, { useMemo, useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { connect } from "react-redux";

import * as actions from "../../../../store/actions";

import SpinnerBorder from "../../../../components/uiElements/loadingSpinner/SpinnerBorder";
import Button from "../../../../components/formElements/button/Button";

const useOptions = () => {
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontSize: 16,
          color: "#424770",
          letterSpacing: "0.025em",
          lineHeight: "2.3em",
          paddingTop: 40,
        },
        invalid: {
          color: "#9e2146",
        },
      },
    }),
    []
  );

  return options;
};

const AddCardForm = ({
  addCard,
  onRemove,
  isLoading,
  isCancelDisabled,
  setLoading,
  createSetupIntent,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();
  const [error, setError] = useState("");
  const [email, setEmail] = useState();

  const handleSubmit = async event => {
    event.preventDefault();

    setLoading(true);

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    setError("");
    createSetupIntent(async data => {
      const confirmPayload = await stripe.confirmCardSetup(
        data?.client_secret,
        {
          payment_method: { card: elements.getElement(CardElement) },
          return_url: "https://dev.urgidoctor.com/onboarding/step6",
        }
      );
      if (confirmPayload?.error) {
        setLoading(false);

        setError(confirmPayload?.error?.message);
      } else {
        addCard(confirmPayload?.setupIntent?.payment_method);
      }
    });

    event.target.reset();
  };

  return (
    <form onSubmit={handleSubmit} className="card-element">
      <label>
        <input
          type="email"
          placeholder="Enter a email"
          name="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          className="w-100"
        />
      </label>
      <label>
        <CardElement options={options} />
      </label>
      <p
        style={{
          color: "red",
        }}
      >
        {error}
      </p>

      <div
        className="col-md-8 d-flex justify-content-center mx-auto"
        style={{
          verticalAlign: "bottom",
          top: 50,
        }}
      >
        <Button
          formType="submit"
          disabled={!stripe}
          label={isLoading ? <SpinnerBorder /> : <span>Add</span>}
        />

        <Button
          type="outline"
          label="Cancel"
          className="ml-2"
          disabled={isCancelDisabled}
          onClick={onRemove}
        />
      </div>
    </form>
  );
};

const mapDispatchToProps = dispatch => ({
  createSetupIntent: cb => dispatch(actions.createSetupIntent(cb)),
});

export default connect(null, mapDispatchToProps)(AddCardForm);
